import React, {Component} from 'react';
import LogoBPJS from '../img/bpjs-small.png';

class TextDesc extends Component {
  render() {
    return(
      <div>
        <div style={{display:'flex', flexDirection: 'row', marginBottom: '15px'}}>
          <img width={40} height={40} src={LogoBPJS} alt="logo bpjs" className="custom-logo-header"/>
          <h3 style={{marginTop: '10px'}}><b className="custom--bpjs-logo-title" >BPJS Ketenagakerjaan</b></h3>
        </div>
        <p className="custom-content-intro">PasarPolis membuat registrasi BPJS Ketenagakerjaan jauh lebih mudah. Dengan BPJS Ketenagakerjaan, jaminan perlindungan sebagai berikut akan ditanggung. Untuk keterangan lebih lanjut, kunjungi situs <a href={`http://bpjsketenagakerjaan.go.id/`} style={{color: '#5D9CE6', fontWeight: 'bold', textDecoration: 'none'}} target="_blank">BPJS Ketenagakerjaan.</a></p>
      </div>
    )
  }
}

export default TextDesc;



// WEBPACK FOOTER //
// ./src/component/Home/Content/text_desc.js